import { action } from '@ember/object';
import LayoutController from 'cio/controllers/layout';

export default class IndexController extends LayoutController {
  @action
  saveLayoutName(name) {
    let model = this.get('model');
    model.set('name', name);
    return model.save();
  }

  @action
  deleteLayout() {
    return this._deleteLayout();
  }
}
